import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Button } from '@material-ui/core';

/**
 * 사용자는 Filezone을 통해 파일을 업로드할 수 있습니다.
 *
 * @version 1.0.0
 * @author [chayeoi](https://github.com/chayeoi)
*/

const S = {
  Button: styled(({ error, ...otherProps }) => (
    <Button {...otherProps} />
  )).attrs({
    variant: 'outlined',
    color: 'primary',
  })`
    height: 40px;
    padding: 0 16px;
    border: 1px solid ${({ theme }) => theme.palette.primary.main};
    ${({ error, theme }) => error && css`
      border-color: ${theme.palette.error.main};
      color: ${theme.palette.error.main};
      :hover {
        border-color: ${theme.palette.error.main};
        background-color: rgba(225, 88, 99, 0.08);
      }
      :focus {
        border: 1px solid ${theme.palette.error.main};
        background-color: rgba(225, 88, 99, 0.08);
      }
    `}
  `,
  Input: styled.input`
    display: none;
  `,
};

const Filezone = ({
  children, className, error, ...otherProps
}) => {
  const input = useRef(null);
  const handleClick = useCallback(() => {
    input.current.click();
  }, []);

  return (
    <S.Button
      className={className}
      tabIndex="0"
      error={error}
      onClick={handleClick}
    >
      <S.Input
        type="file"
        tabIndex="-1"
        ref={input}
        {...otherProps}
      />
      {children}
    </S.Button>
  );
};

Filezone.propTypes = {
  /** 버튼 라벨 */
  children: PropTypes.node,
  /**
   * @ignore
  */
  className: PropTypes.string,
  /** 에러 발생 여부 */
  error: PropTypes.bool,
  /**
   * 파일이 변경되었을 때 호출될 콜백 함수
   *
   * @param {React.SyntheticEvent} event 합성 이벤트 객체
   */
  onChange: PropTypes.func.isRequired,
};

Filezone.defaultProps = {
  children: '',
  className: undefined,
  error: false,
};

export default Filezone;
